import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { withRouter, Link } from 'react-router-dom';
import swal from "sweetalert2";
import DateTime from "_class/DateTime";
import { getPlanAssessments } from "actions/assessments";
import { setPageTitle } from "actions/header";
import { addError } from "actions/index";
import { getBlocksByReference, clearBlocksOnReference } from 'actions/blocks';
import { deletePlan, getPlanDetails, setActivePlan, updatePlan, getPlanSection } from "actions/plans";
import { getReaderParameters } from "actions/user";
import { trackImmersiveReaderError } from "helpers/insights";
import { getRootUrl } from "helpers/url";
import { isUserStudent, isUserTeacher } from "helpers/user";
import { getImmersiveReaderDataFromBlocks } from "helpers/content";
import UserPlanning from "components/List/UserPlanning";
import DateSpan from "components/Presentation/Date/DateSpan";
import SelectedCoreContent from "containers/CoreContent/Selected";
import TeacherAdjustments from "containers/AdditionalAdjustments/Display/TeacherAdjustments";
import Modal from "containers/Modals/Modal";
import SinglePlanForm from "containers/Forms/PlanningForm/SinglePlanForm";
import CloneButton from "containers/SinglePages/Partials/CloneButton";
import Message from "containers/SinglePages/Partials/Message";
import Bookmark from 'containers/SinglePages/Partials/Bookmark';
import BlockConsumer from 'components/BlockEditor/Consumer';
import AssessmentsConsumer from 'components/BlockAssessments/Consumer';
import { Block as ContentBlock, Button, Icon } from "@haldor/ui";
import { Immersive_Reader } from "UI/Icons";
import { Collapsible, Expandable, List, Spinner } from "UI";
import moment from "moment";
import BlockPurpose from "components/Inputs/BlockPurposeField";

var ImmersiveReader = require("@microsoft/immersive-reader-sdk");

var CompulsoryPlan = /*#__PURE__*/function (_Component) {
  _inherits(CompulsoryPlan, _Component);

  var _super = _createSuper(CompulsoryPlan);

  function CompulsoryPlan(props) {
    var _this;

    _classCallCheck(this, CompulsoryPlan);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.match.params.planId > 0) {
        _this.reload();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      ImmersiveReader.close();

      _this.props.clearBlocksOnReference();
    });

    _defineProperty(_assertThisInitialized(_this), "reload", function () {
      if (!_this.state.loading) {
        _this.setState({
          loading: true,
          loadingSection: true,
          loadingBlocks: true
        });

        _this.props.getPlanDetails(_this.props.match.params.planId, null).then(function () {
          _this.setState({
            loading: false
          });

          if (_this.props.plan == null || _this.props.plan === "") {
            return false;
          }

          _this.props.setPageTitle(_this.props.plan.title);

          _this.props.getPlanSection(_this.props.plan.sectionId).then(function () {
            _this.setState({
              loadingSection: false
            });
          });
        })["catch"](function (error) {
          if (error.response != null) {
            if (error.response.data != null && error.response.data.errorCode) {
              switch (error.response.data.errorCode) {
                case 'PLANNINGBL-001':
                  _this.setState({
                    loading: false,
                    notFound: true
                  });

                  break;
              }
            }
          }
        });

        _this.props.getBlocksByReference(_this.props.match.params.planId, 'PLAN').then(function () {
          _this.setState({
            loadingBlocks: false
          });
        });

        _this.props.getPlanAssessments(_this.props.match.params.planId);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "runImmersiveReader", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, plan, currentUser, localLanguage, reader, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, plan = _this$props.plan, currentUser = _this$props.currentUser;
              localLanguage = localStorage.getItem("language");
              _context.next = 4;
              return _this.props.getReaderParameters();

            case 4:
              reader = _this.props.reader;

              if (!(reader == null)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              data = getImmersiveReaderDataFromBlocks(plan.title, _this.props.blocks);
              data.chunks.unshift({
                content: "<h3>\n\t\t\t\t".concat(_this.props.translate('Content'), "\n\t\t\t</h3>"),
                mimeType: "text/html"
              });
              ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
                uiLang: localLanguage // Set immersive reader UI language to selected lang in Haldor Edu

              })["catch"](function (error) {
                console.error("error", error);
                trackImmersiveReaderError(error, currentUser.id);
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "readPlanInformation", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props2, plan, currentUser, translate, localLanguage, reader, start, end, status, data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, plan = _this$props2.plan, currentUser = _this$props2.currentUser, translate = _this$props2.translate;
              localLanguage = localStorage.getItem("language");
              _context2.next = 4;
              return _this.props.getReaderParameters();

            case 4:
              reader = _this.props.reader;

              if (!(reader == null)) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return");

            case 7:
              start = new DateTime(plan.timeStart).getShortDate();
              end = new DateTime(plan.timeEnd).getShortDate();
              status = translate('open');

              if (plan.status == 'PLANNING_CLOSED') {
                status = translate('Closed');
              }

              if (plan.status == 'PLANNING_DRAFT') {
                status = translate('Draft');
              }

              data = {
                title: plan.title,
                chunks: [{
                  content: "<h3>\n\t\t\t\t\t\t".concat(translate('Plan information'), "\n\t\t\t\t\t</h3>"),
                  mimeType: "text/html"
                }, {
                  content: "\n\t\t\t\t\t\t".concat(translate('Plan is active between'), ":\n\t\t\t\t\t\t").concat(start, " - ").concat(end, " and the current status is: ").concat(status, "\n\t\t\t\t\t\t</br>\n\t\t\t\t\t"),
                  mimeType: "text/html"
                }, {
                  content: "\n\t\t\t\t\t\t".concat(translate('It belongs to the group named'), ":\n\t\t\t\t\t\t").concat(plan.section.title, "\n\t\t\t\t\t\t</br>\n\t\t\t\t\t"),
                  mimeType: "text/html"
                }]
              };
              ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
                uiLang: localLanguage // Set immersive reader UI language to selected lang in Haldor Edu

              })["catch"](function (error) {
                console.error("error", error);
                trackImmersiveReaderError(error, currentUser.id);
              });

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "toggleDeletion", function () {
      swal.fire({
        title: _this.props.translate("Delete"),
        text: _this.props.translate("delete-plan-prompt"),
        showCancelButton: true,
        cancelButtonText: _this.props.translate("Cancel"),
        confirmButtonText: _this.props.translate("Delete")
      }).then(function (response) {
        if (response.value != null) {
          _this.props.deletePlan(_this.props.match.params.planId).then(function () {
            if (getRootUrl() != "/") {
              _this.props.history.push("/planning-tab");
            } else {
              _this.props.history.push("/");
            }
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "markStudentForConversation", function (student) {
      _this.setState({
        studentConversation: student
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onConversationClose", function () {
      _this.setState({
        studentConversation: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openStudentConversation", function () {
      var _this$props3 = _this.props,
          currentUser = _this$props3.currentUser,
          plan = _this$props3.plan;

      if (_this.props.activeSection != null) {
        var owner = _this.props.activeSection.owners.find(function (owner) {
          return owner.id == plan.creator;
        });

        var teacher = {
          id: owner.id,
          firstname: owner.firstName,
          lastname: owner.lastName,
          email: owner.email,
          userType: owner.userType
        };

        if (teacher != null) {
          _this.setState({
            studentConversation: teacher
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function (reRender, skipPrompt) {
      if (reRender) {
        _this.reload();
      }

      _this.setState({
        modalIsOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        modalIsOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderPlanStatus", function () {
      if (_this.props.plan != null) {
        if (_this.props.plan.locked) {
          return /*#__PURE__*/React.createElement("span", {
            className: "dot dot-red"
          }, _this.props.translate("plan-is-processing"));
        }

        var status = _this.props.plan.status;
        var assessed = false;

        if (_this.props.assessments != null) {
          if (_this.props.assessments.length > 0) {
            assessed = true;
          }
        }

        if (assessed == false) {
          if (status === "PLANNING_OPEN") {
            return /*#__PURE__*/React.createElement("span", {
              className: "dot dot-green"
            }, _this.props.translate("open"));
          } else if (status === "PLANNING_CLOSED") {
            return /*#__PURE__*/React.createElement("span", {
              className: "dot dot-red"
            }, _this.props.translate("Closed"));
          } else if (status === "PLANNING_DRAFT") {
            return /*#__PURE__*/React.createElement("span", {
              className: "dot dot-gray"
            }, _this.props.translate("draft"));
          }
        } else {
          return /*#__PURE__*/React.createElement("span", {
            className: "dot dot-green"
          }, _this.props.translate("assessed"));
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderModals", function () {
      var translate = _this.props.translate;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.modalIsOpen,
        onClose: _this.closeModal,
        title: translate("edit-plan")
      }, /*#__PURE__*/React.createElement(SinglePlanForm, {
        onAbort: _this.closeModal,
        editView: true,
        cloneView: false
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPrintButton", function () {
      console.log(_this.props.match.params.planId);
      var url = "/haldor-tab/print/plan/".concat(_this.props.match.params.planId);
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(Link, {
        style: {
          display: 'inline'
        },
        to: url
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Printer"
      }), _this.props.translate("printable-view"))));
    });

    _defineProperty(_assertThisInitialized(_this), "planContent", function () {
      var _assessmentBlocks, _this$props$activeSec2, _this$props$activeSec3;

      var plan = _this.props.plan;
      var isStudent = isUserStudent(_this.props.currentUser);
      var isTeacher = isUserTeacher(_this.props.currentUser);
      var teacherOwnsPlan = false;

      if (_this.props.activeSection != null) {
        var _this$props$activeSec;

        teacherOwnsPlan = ((_this$props$activeSec = _this.props.activeSection.owners) === null || _this$props$activeSec === void 0 ? void 0 : _this$props$activeSec.find(function (owner) {
          return owner.userId == _this.props.currentUser.userId;
        })) != null;
      }

      var subjects = [];
      var assessmentBlocks = [];
      var assessment = null;
      var conversation = null;

      if (_this.props.conversations != null && !isTeacher) {
        conversation = _this.props.conversations.find(function (conv) {
          return conv.memberships.find(function (member) {
            return member.membershipID == _this.props.currentUser.id;
          });
        });
      }

      if (isStudent && _this.props.assessments.length > 0) {
        assessment = _this.props.assessments[0];
      }

      if (_this.props.blocks != null) {
        assessmentBlocks = _toConsumableArray(_this.props.blocks).filter(function (block) {
          return block.type == 'Haldor.Blocks.AssessmentBlock' && block.resources.length > 0;
        });
      }

      var expiredCourses = [];

      if (((_assessmentBlocks = assessmentBlocks) === null || _assessmentBlocks === void 0 ? void 0 : _assessmentBlocks.length) > 0) {
        var _assessmentBlocks2;

        (_assessmentBlocks2 = assessmentBlocks) === null || _assessmentBlocks2 === void 0 ? void 0 : _assessmentBlocks2.forEach(function (content) {
          var _content$resources;

          content === null || content === void 0 ? void 0 : (_content$resources = content.resources) === null || _content$resources === void 0 ? void 0 : _content$resources.forEach(function (resources) {
            var _resources$value;

            switch (resources.referenceType) {
              case 'matrix':
                var matrixId = resources.referenceId;
                var detail = (_resources$value = resources.value) === null || _resources$value === void 0 ? void 0 : _resources$value.details.find(function (detail) {
                  return detail.matrixID == matrixId;
                });

                if (detail != null && detail.endDate != null && moment(detail.endDate).isBefore(moment())) {
                  expiredCourses.push(detail.courseID);
                }

                break;

              default:
                break;
            }

            if ((resources === null || resources === void 0 ? void 0 : resources.value) != null) {
              var _resources$value2;

              if (subjects.indexOf((_resources$value2 = resources.value) === null || _resources$value2 === void 0 ? void 0 : _resources$value2.subjectId) == -1) {
                var _resources$value3;

                subjects.push(parseInt((_resources$value3 = resources.value) === null || _resources$value3 === void 0 ? void 0 : _resources$value3.subjectId));
              }
            }
          });
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "single-plan single-task",
        key: plan.id
      }, isStudent && !teacherOwnsPlan ? null : _this.renderModals(), /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side"
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, _this.props.translate("tools")), _this.props.services.conversations && !isTeacher ? /*#__PURE__*/React.createElement(Button, {
        type: conversation == null ? "secondary" : "primary",
        onClick: _this.openStudentConversation
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Message",
        bw: true
      }), _this.props.translate("conversation"), conversation != null && conversation.unreadMessages > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "badge"
      }, /*#__PURE__*/React.createElement("span", null, conversation.unreadMessages)) : null) : null, isStudent || !teacherOwnsPlan || _this.state.loadingBlocks ? null : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginTop: 5
        },
        onClick: _this.openModal,
        disabled: plan.locked
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      }), " ", _this.props.translate("Edit"))), _this.renderPrintButton(), isStudent || !teacherOwnsPlan || plan.isDeletable == false ? null : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginTop: 5
        },
        onClick: _this.toggleDeletion
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      }), " ", _this.props.translate("Delete"))), !isStudent ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(CloneButton, {
        onClose: _this.reload,
        object: plan,
        type: "planning"
      }, _this.props.translate('column-copy'))) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side"
      }, /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement(Expandable, {
        title: _this.props.translate('Planning information'),
        open: true
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '.7rem'
        }
      }, _this.props.services.immersiveReaderPlans ? /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: _this.readPlanInformation
      }, /*#__PURE__*/React.createElement("div", {
        className: "reader trigger"
      }, /*#__PURE__*/React.createElement(Immersive_Reader, null), _this.props.translate("immersive-reader"))) : null, isTeacher ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, /*#__PURE__*/React.createElement(Bookmark, {
        referenceType: "PLAN",
        referenceId: plan.id
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DateSpan, {
        start: plan.timeStart,
        end: plan.timeEnd
      }), _this.props.plan.status == 'PLANNING_DRAFT' ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginLeft: 5
        }
      }, _this.props.translate('Draft')) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1rem"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate("section")), plan.section.title), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1rem"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate("status")), _this.renderPlanStatus(), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), plan.courses.length > 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1rem"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate("Courses")), /*#__PURE__*/React.createElement("div", {
        className: "courses"
      }, plan.courses.map(function (course) {
        var text = course.title;

        if (course.year != null) {
          text += " " + course.year;
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "course",
          key: 'course' + course.id
        }, expiredCourses.indexOf(course.id) > -1 ? /*#__PURE__*/React.createElement("div", {
          style: {
            width: '1.75rem',
            position: 'relative'
          }
        }, " ", /*#__PURE__*/React.createElement(Icon, {
          name: "Alert_Red"
        }), " ") : /*#__PURE__*/React.createElement("span", {
          className: "indicator",
          style: {
            backgroundColor: course.colorCode
          }
        }), text);
      }))) : null, _this.props.services.additionalAdjustments && isTeacher && _this.props.activeSection && ((_this$props$activeSec2 = _this.props.activeSection) === null || _this$props$activeSec2 === void 0 ? void 0 : (_this$props$activeSec3 = _this$props$activeSec2.owners) === null || _this$props$activeSec3 === void 0 ? void 0 : _this$props$activeSec3.filter(function (ss) {
        return ss.id == _this.props.currentUser.id;
      }).length) > 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1rem"
        }
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: _this.props.translate("additional-adjustments")
      }, /*#__PURE__*/React.createElement(TeacherAdjustments, {
        groupId: plan.sectionId,
        subjects: subjects
      }))) : null))), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: "both"
        }
      }), _this.props.blocks != null && !_this.state.loadingBlocks ? /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement(Expandable, {
        title: _this.props.translate("Content"),
        open: true
      }, _this.props.services.immersiveReaderPlans ? /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: _this.runImmersiveReader
      }, /*#__PURE__*/React.createElement("div", {
        className: "reader trigger"
      }, /*#__PURE__*/React.createElement(Immersive_Reader, null), _this.props.translate("immersive-reader"))) : null, /*#__PURE__*/React.createElement(BlockConsumer, {
        fields: _this.props.blocks
      }))) : /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement(Expandable, {
        title: _this.props.translate("Content"),
        open: true
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: "3em"
        },
        className: "single-section-divider"
      }), _this.props.services.conversations ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Message, {
        plan: plan,
        activeUser: _this.state.studentConversation,
        onClose: _this.onConversationClose
      })) : null, isStudent == false && teacherOwnsPlan && _this.props.plan.students != null && _this.props.plan.students.length > 0 ? /*#__PURE__*/React.createElement(List, {
        title: _this.props.translate("students")
      }, /*#__PURE__*/React.createElement(UserPlanning, {
        items: _this.props.plan.students,
        planId: _this.props.match.params.planId,
        reload: _this.reload,
        printable: false,
        onConversation: _this.markStudentForConversation
      })) : null, (isTeacher || _this.props.plan.viewablePurpose) && assessmentBlocks.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement("h3", {
        style: {
          marginBottom: '1rem',
          fontWeight: 500
        }
      }, _this.props.translate('Aim')), /*#__PURE__*/React.createElement(BlockPurpose, {
        assessmentBlocks: assessmentBlocks
      })) : null, (isTeacher || _this.props.plan.viewableCoreContent) && _this.props.plan.associatedCoreContent.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement(SelectedCoreContent, {
        associatedCoreContent: _this.props.plan.associatedCoreContent,
        assessmentBlocks: assessmentBlocks
      })) : null, _this.state.loadingBlocks ? /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement("h3", {
        style: {
          marginBottom: '1rem',
          fontWeight: 500
        }
      }, _this.props.translate('Assessment')), /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })) : null, assessmentBlocks.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement(AssessmentsConsumer, {
        fields: assessmentBlocks,
        assessment: assessment,
        isStudent: isStudent
      })) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          clear: "both"
        }
      }));
    });

    _this.state = {
      modalIsOpen: false,
      loading: false,
      loadingSection: false,
      loadingBlocks: true,
      studentConversation: null,
      notFound: false
    };

    _this.closeModal.bind(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(CompulsoryPlan, [{
    key: "render",
    value: function render() {
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      } else if (this.state.notFound) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task center-container"
        }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('not-found')));
      } // Check if plan is null


      if (this.props.plan == null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task"
        }, /*#__PURE__*/React.createElement("div", {
          className: "single-section left-side"
        }, /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement("div", {
          style: {
            padding: '1rem 0'
          },
          className: "text--center color--meta weight--bold"
        }, this.props.translate('plan-has-been-deleted')))), /*#__PURE__*/React.createElement("div", {
          className: "single-actions right-side"
        }));
      }

      if (Object.keys(this.props.plan).length > 0) {
        return /*#__PURE__*/React.createElement("div", null, this.planContent());
      } else {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
    }
  }]);

  return CompulsoryPlan;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    services: state.Services.availableServices,
    plan: state.planning.active_plan,
    currentUser: state.user.currentUser,
    sections: state.sections.educationGroups,
    activeSection: state.sections.activeSection,
    assessments: state.assessments.assessments,
    conversations: state.Conversation.referenceConversations,
    reader: state.user.reader,
    blocks: state.Blocks.reference
  };
}

export default withRouter(connect(mapStateToProps, {
  getPlanDetails: getPlanDetails,
  getPlanAssessments: getPlanAssessments,
  addError: addError,
  deletePlan: deletePlan,
  getPlanSection: getPlanSection,
  setActivePlan: setActivePlan,
  updatePlan: updatePlan,
  setPageTitle: setPageTitle,
  getReaderParameters: getReaderParameters,
  getBlocksByReference: getBlocksByReference,
  clearBlocksOnReference: clearBlocksOnReference
})(CompulsoryPlan));